<template>
	<div>
		<v-toolbar :dark="$dark()" light dense flat>
		 	<v-toolbar-items>
		 		<v-btn flat color="deep-orange" @click="back_to_list">&lt; Back to list</v-btn>
		 	</v-toolbar-items>
	 		<v-toolbar-title v-if="event">
		 		{{event_start_time}} - {{event_title}}
		 	</v-toolbar-title>
    </v-toolbar>

		<v-layout row v-if="event" class="mt-4">
			<v-flex xs12 class="pr-3">

				<div class="elevation-1 pb-5 pr-2 pl-2 pt-2" v-if="read_only != true">

					<v-layout row>

						<v-flex md6 xs12>
							<v-toolbar :color="$dark() ? 'grey darken-4' : 'deep-orange'" dark dense>
      					<v-toolbar-title>Vod</v-toolbar-title>
					    </v-toolbar>
							<vod-view :uuid="uuid" :new-positions="new_positions" :disable-key-events="disable_key_events"></vod-view>
						</v-flex>

						<v-flex md6 v-if="is_live" class="ml-2 hidden-sm-and-down"> <!-- Live player -->
							<v-toolbar :color="$dark() ? 'grey darken-4' : 'deep-orange'" dark dense>
      					<v-toolbar-title>Live</v-toolbar-title>
					    </v-toolbar>
							<live-view :uuid="uuid" v-on:clip="live_to_clip"></live-view>
						</v-flex>

					</v-layout>

				</div>

				<div v-if="account">
							<clips-view :uuid="uuid" @disable-key-events="disable_key_events = $event"></clips-view>
					</div>

			</v-flex>
		</v-layout>
	</div>

</template>

<script>
import moment from 'moment'
import vueSlider from 'vue-slider-component';
import LiveView from './Live.vue';
import VodView from './Vod.vue';
import ClipsView from './Clips.vue';
import EventModel from '@/models/event.js'



export default {
	props: ["uuid"],
	components: {
		LiveView,
		VodView,
		ClipsView,
	},
	data () {
		var event_ch = this.$cloudserver.channel("events:"+this.uuid);
		return {
			ws_channel: event_ch,
			event: undefined,
			in_position: undefined,
			out_position: undefined,
			new_positions: [undefined,undefined],
			disable_key_events: false,
			start: 0,
			end: 0
		}
	},
	watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				if(typeof(newVal) != "undefined") {
					this.event = newVal;
				}
			},
			deep: true
		},
		"event": function(newVal) {
			if (typeof(newVal) != "undefined") {
				if (typeof(this.start) != "undefined" && typeof(this.end) != "undefined" && this.start != 0 && this.end != 0) {
					var start = (this.start - (this.event.cached_start_time * 1000)) / 1000.0;
					var end = (this.end - (this.event.cached_start_time * 1000)) / 1000.0;
					this.new_positions = [start, end];
				}
			}
		},
	},
	created () {
		var self = this;
		this.ws_channel.join();
	},
	mounted () {
		this.start = parseInt(this.$route.query.start,10);
		this.end = parseInt(this.$route.query.end,10);
	},
	methods: {
		back_to_list () {
			this.$router.push("/cloudrec")
		},
		live_to_clip (value) {
			this.in_position = value.position - value.length;
			this.out_position = value.position;

			this.new_positions = [this.in_position, this.out_position];
		
		}
	},
	computed: {
		is_live () {
			return EventModel.is_current(this.event);
		},
		event_start_time() {
			var t = moment(this.event.cached_start_time * 1000);
			return t.format("L LTS");
		},
		event_title() {
			return EventModel.title(this.event);
		},
		read_only() {
			if (typeof(this.account) == "undefined") return true;
			if (typeof(this.account.meta) == "undefined") return true;
			if (this.account.meta.rec_readonly == true) {
				this.clip_filter = "all";
				return true;
			}
		},
		account () {
			return this.$store.state.account;
		}
	}
}
</script>